<template>
  <div>
    <MainNav
      v-if="!isUserCenterRoute"
      :isUserLoggedIn="isUserLoggedIn"
      :brandLogo="logoUrl"
      :walletAddress="walletAddress"
      :toggleWalletConnection="toggleWalletConnection"
      @change-language="changeLanguage"
    />
    <UserCenterNav
      v-else
      :isUserLoggedIn="isUserLoggedIn"
      :brandLogo="logoUrl"
      :walletAddress="walletAddress"
      :toggleWalletConnection="toggleWalletConnection"
      @change-language="changeLanguage"
      @toogle-sidebar="toogleSidebar"
    />
  </div>
</template>

<script>
import MainNav from '@/components/MainNav.vue';
import UserCenterNav from '@/components/UserCenterNav.vue';
import { mapState, mapActions } from 'vuex';
import { fetchBrandLogo } from '@/api/apiService';
import emitter from '@/utils/eventBus';
export default {
  components: {
    MainNav,
    UserCenterNav,
  },
  data() {
    return {
      logoUrl: '',
    };
  },
  props: {
    walletConnect: {
      type: Object,
      default: null,
    },
  },
  computed: {
    ...mapState({
      isUserLoggedIn: state => state.isUserLoggedIn,
      walletAddress: state => state.userProfile.walletAddress || '',
    }),
    isUserCenterRoute() {
      return this.$route.path.startsWith('/dashboard');
    },
  },
  mounted() {

    const inviteCode = this.$route.query.inviteCode;
    if (inviteCode != "" && inviteCode != '' && inviteCode != undefined && inviteCode != null && inviteCode != 'undefined') {
      localStorage.setItem('inviteCode', inviteCode);
    }
    this.fetchLogo();
    emitter.on('toogle-wallet-connection', this.toggleWalletConnection);
  },
  methods: {
    ...mapActions(['bindUserAccount', 'fetchUserProfile', 'logout']),
    toggleWalletConnection() {
      if (this.walletConnect) {
        this.setLoading(true);
        this.walletConnect.toggleConnect().finally(() => {
          this.setLoading(false);
        });
      }
    },
    toogleSidebar() {
      emitter.emit('toogle-drawer');
    },
    setLoading(value) {
      this.loading = value;
      if(value){
        this.$toast.showMarkLoading();
      } else {
        this.$toast.hideMarkLoading();
      }
    },
    changeLanguage(lang, label) {
      this.$i18n.locale = lang;
      localStorage.setItem('language', lang);
      localStorage.setItem('languageLabel', label);
    },
    async fetchLogo() {
      try {
        const response = await fetchBrandLogo();
        this.logoUrl = response.url;
      } catch (error) {
        console.error('Failed to fetch brand logo:', error);
      }
    },
  },
};
</script>